export default __webpack_public_path__ + "static/media/hra-hero-icon.04abcba4.svg";